import React, { useEffect, useState } from "react";
import CreationSummary from "./CreationSummary";
import { CardIcon, CardIcon2, CardIcon3, CardIcon4 } from "../../../assets/icons";
import { httpService } from "../../../base/services/httpService.service";
import "../style.scss";
import AuthService from "../../../base/services/authentication.service";
import { UserRolesEnum } from "../../auth/userRoles.enum";

const SummaryCreationData = () => {
   const [summaryData, setSummaryData] = useState({});
   const isSuperAdmin = AuthService.isAuthorized([UserRolesEnum.SuperAdmin]);

   const getAmountOfStorage = async () => {
      try {
         isSuperAdmin
            ? await httpService.get("/DataUsage/numbers", (res) => {
                 setSummaryData(res?.data);
              })
            : await httpService.get("/DataUsage/ngo/numbers", (res) => {
                 setSummaryData(res?.data);
              });
      } catch (error) {
         console.log(error);
      }
   };

   useEffect(() => {
      getAmountOfStorage();
   }, []);

   const fields = [
      {
         propertyType: AuthService.isAuthorized([UserRolesEnum.NationalOrganization]) ? "Surveys available" : "Surveys created",
         image: CardIcon,
         count: summaryData?.surveysCount
      },
      {
         propertyType: AuthService.isAuthorized([UserRolesEnum.NationalOrganization]) ? "Assessments available" : "Assessments created",
         image: CardIcon2,
         count: summaryData?.assessmentsCount
      },
      {
         propertyType: AuthService.isAuthorized([UserRolesEnum.NationalOrganization]) ? "Workspaces available" : "Workspaces created",
         image: CardIcon3,
         count: summaryData?.workspacesCount
      },
      {
         propertyType: "Members",
         aditionalForMember: AuthService.isAuthorized([UserRolesEnum.NationalOrganization]) ? "" : "including humanitarian experts created",
         image: CardIcon4,
         count: summaryData?.usersCount
      }
   ];

   return (
      <div className="creation-summary-grid">
         {fields.map((dataType, index) => (
            <div key={index}>
               <CreationSummary {...dataType} />
            </div>
         ))}
      </div>
   );
};

export default SummaryCreationData;
